import {AppError} from '../../utils/errors';

// API_ERRORS[166] ("Location segmentation required") isn't fixed by a reload
// like most errors here — the user has to go re-run location segmentation in
// Connect. Studio doesn't route users into this error in practice (it heads
// off stale layouts with its own resegmentation banner), so this is handled
// as a one-off rather than built out into a generic per-app action system.
const LOCATION_SEGMENTATION_REQUIRED_CODE = 166;

export function isLocationSegmentationRequired(error: unknown): boolean {
  return (
    error instanceof AppError &&
    error.code === LOCATION_SEGMENTATION_REQUIRED_CODE
  );
}
